import { render } from "./BoothInfo.vue?vue&type=template&id=1c8bbf5c&scoped=true"
import script from "./BoothInfo.vue?vue&type=script&lang=js"
export * from "./BoothInfo.vue?vue&type=script&lang=js"

import "./BoothInfo.vue?vue&type=style&index=0&id=1c8bbf5c&lang=scss&scoped=true"

import exportComponent from "D:\\PROJECT\\Mbf5_HCC\\XaTanHungHph\\web-ui\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-1c8bbf5c"]])

export default __exports__